import { fabric } from 'fabric';
import CanvasObject from "./CanvasObject";
import Canvas from "./../Canvas";
import CanvasDebug from "../../CanvasDebug";
import BoundingBox from "./BoundingBox";

class AdminBoundingBox extends BoundingBox {

    /**
     * Create a BoundingBox.
     * @param {Canvas} canvas Instance of the canvas on which the object is displayed.
     * @param {number} minX Smallest value that can be defined for the property left.
     * @param {number} maxX Highest value that can be defined for the property left.
     * @param {number} minY Smallest value that can be defined for the property top.
     * @param {number} maxY Highest value that can be defined for the property top.
     */
    constructor(canvas, minX, maxX, minY, maxY) {
        super(canvas, minX, maxX, minY, maxY);
        this._minX = minX;
        this._maxX = maxX;
        this._minY = minY;
        this._maxY = maxY;
    }

    /**
     * Returns a new FabricObject that can be added to the canvas.
     * @returns {Promise<fabric.Object>}
     */
    async createFabricObject() {

        if (this.getCanvas().getFactor() === 0 || this.getHeight() === 0 || this.getWidth() === 0) {
            return null;
        }

        return new fabric.Rect({
            id: this.getId(),
            height: this.getHeight() + 2,
            width: this.getWidth() + 2,
            top: this.getTop() - 2,
            left: this.getLeft() - 2,
            fill: 'transparent',
            stroke: 'grey',
            strokeWidth: 2,
            strokeDashArray: [ 5 ],
            selectable: true,
            evented: true
        });

    }

    readFromFabricObject() {

        /**
         * @type {fabric.Object}
         */
        const fabricObject = this.getMatchingFabricObject();

        this.setTop(fabricObject.top);
        this.setLeft(fabricObject.left);
        this.setHeight(fabricObject.height - 2);
        this.setWidth(fabricObject.width - 2);

        return fabricObject;

    }

    // Getter & Setter Methods

    setMaxX(value) {
        this._maxX = value;
    }

    setMaxY(value) {
        this._maxY = value;
    }

    setTop(value, parent = false) {

        if (parent) {
            this._top = value;
            return;
        }

        this._minY = value;
        this._maxY = value;
        this._top =  value;

    }

    setLeft(value, parent = false) {

        if (parent) {
            this._left = value;
            return;
        }

        this._minX = value;
        this._maxX = value;
        this._left = value;

    }

}

export default AdminBoundingBox;